export async function checkPassword( password: String | null ) {
	return (true);
}
